<main class="col-sm-12 ms-sm-auto" role="main" *ngIf="!(loading$ | async)">
  <div class="row px-4">
    <div class="col-md-6 col-lg-4 mb-3" *ngIf="(topLevel$ | async)?.length > 0">
      <div class="card h-100">
        <h5 class="card-header d-inline">
          <fa-icon icon="desktop" class="me-2 text-primary"></fa-icon>
          Surescripts Products
        </h5>
        <div class="card-body">
          <p></p>
          <div class="card-text">
            <ul>
              <li *ngFor="let product of topLevel$ | async">
                <a href="{{ product.link }}" id="{{ product.id }}">{{
                  product.text
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="(withChildren$ | async)?.length > 0">
      <div
        class="col-md-6 col-lg-4 mb-3"
        *ngFor="let product of withChildren$ | async"
      >
        <div class="card h-100">
          <h5 class="card-header">
            <fa-icon
              *ngIf="product.iconId"
              [icon]="product.iconId"
              class="text-primary"
              [ngStyle]="{'margin-right': '1rem'}"
            ></fa-icon>

            <span
              *ngIf="!product.link || product.link.trim() === ''; else hasUrl"
              id="{{ product.id }}"
              >{{ product.text }}</span
            >
            <ng-template #hasUrl>
              <a href="{{ product.link }}" id="{{ product.id }}">{{
                product.text
              }}</a>
            </ng-template>
          </h5>
          <div class="card-body">
            <p>{{ product.description }}</p>

            <div class="card-text">
              <ul>
                <li *ngFor="let child of product.children" class="mb-1">
                  <span
                    *ngIf="!child.link || child.link.trim() === ''; else hasUrl"
                    id="{{ child.id }}"
                    >{{ child.text }}</span
                  >
                  <ng-template #hasUrl>
                    <a href="{{ child.link }}" id="{{ child.id }}">{{
                      child.text
                    }}</a>
                  </ng-template>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</main>
